module.exports = __webpack_public_path__ + "09e33040fe8231ba0b5f90e8c2c0fd79.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/students.png
// module id = 1704
// module chunks = 0